import { render, staticRenderFns } from "./examenfinalizado.vue?vue&type=template&id=3c8ca2f6&scoped=true&"
import script from "./examenfinalizado.vue?vue&type=script&lang=js&"
export * from "./examenfinalizado.vue?vue&type=script&lang=js&"
import style0 from "./examenfinalizado.vue?vue&type=style&index=0&id=3c8ca2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ca2f6",
  null
  
)

export default component.exports